<template>
  <SourceContainer>Source: {{ this.source }}</SourceContainer>
</template>

<script>
import { SourceContainer } from './dataSource.styles';

export default {
  props: { source: { type: String, default: '' } },
  components: { SourceContainer },
};
</script>
